import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from 'components/Heading';
import InlineList from 'components/InlineList';
import Stack from 'components/Stack';
import Text from 'components/Text';
import Landmark from 'components/Landmark';
import MeetingItem from './MeetingItem';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function MeetingSection(_ref) {
  var _ref$userMeetings = _ref.userMeetings,
    userMeetings = _ref$userMeetings === void 0 ? [] : _ref$userMeetings,
    getLocation = _ref.getLocation,
    _ref$decimalPlaces = _ref.decimalPlaces,
    decimalPlaces = _ref$decimalPlaces === void 0 ? 0 : _ref$decimalPlaces;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs("section", {
    "aria-labelledby": "meetings-this-week-heading",
    children: [/*#__PURE__*/_jsx(Heading, {
      as: "h3",
      size: "small",
      mb: "s",
      id: "meetings-this-week-heading",
      children: t('skills_title_meetings_this_week')
    }), (userMeetings === null || userMeetings === void 0 ? void 0 : userMeetings.length) === 0 ? /*#__PURE__*/_jsx(Landmark, {
      height: 100,
      children: /*#__PURE__*/_jsx(Text, {
        dimmed: true,
        children: t('amount_none')
      })
    }) : /*#__PURE__*/_jsx(Stack, {
      spacing: "xs",
      as: "list",
      children: userMeetings.map(function (meeting) {
        var startTime = new Date(meeting.startTime);
        var formattedDate = startTime.toLocaleDateString('en-GB', {
          dateStyle: 'medium'
        });
        var formattedTime = startTime.toLocaleTimeString('en-GB', {
          timeStyle: 'short',
          hour12: true
        });
        return /*#__PURE__*/_jsx(MeetingItem, {
          score: meeting.score,
          decimalPlaces: decimalPlaces,
          subtitle: /*#__PURE__*/_jsxs(InlineList, {
            splitBy: "dot",
            as: "p",
            itemAs: "span",
            display: "inline",
            children: [formattedDate, formattedTime]
          }),
          title: meeting.title || '',
          link: getLocation({
            meetingId: meeting.meetingId
          })
        }, meeting.meetingId);
      })
    })]
  });
}
export default MeetingSection;